import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const saved = sessionStorage.getItem("pillScrollLeft")
    if (saved !== null) {
      this.element.scrollLeft = parseInt(saved, 10)
    }

    this.element.addEventListener("click", this.save.bind(this))
  }

  save() {
    sessionStorage.setItem("pillScrollLeft", this.element.scrollLeft)
  }
}
